export const customTooltipDefaults = {
    showDelay: 500,
    hideDelay: 500,
    touchendHideDelay: 5000
};
